import React, { Component, createRef } from 'react'
import { safeParse } from '../utils';
const Parser = safeParse;
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'

// Импорт стилей Swiper
import 'swiper/css'
import 'swiper/css/navigation'

class App extends Component {
  static defaultProps = {
    more: true
  };

  constructor(props) {
    super(props)
    this.swiperRef = createRef()
    this.state = {
      isBeginning: true,
      isEnd: false
    }
  }

  handleSlideChange = (swiper) => {
    this.setState({
      isBeginning: swiper.isBeginning,
      isEnd: swiper.isEnd
    })
  }

  render() {
    const { more, data } = this.props
    const { block_news } = data
    const { isBeginning, isEnd } = this.state

    return (
      <div className='mt-[70px] xl:mt-[80px] tracking-[-0.04em] leading-none'>
        {/* Микроразметка ItemList новостей */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ItemList",
            "name": block_news?.title,
            "itemListElement": (block_news?.cards || []).map((elm, index) => ({
              "@type": "ListItem",
              "position": index + 1,
              "url": elm?.more,
              "name": elm?.name
            }))
          })}
        </script>
        <div className='container'>
          <div className='flex items-center justify-center xl:justify-start gap-[10px] text-[14px]'>
            <div className='inline-flex items-center px-[15px] h-[38px] bg-[#F5F7F9] rounded-full gap-[5px] text-[14px] xl:text-[16px]'>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.4498 5.06879L13.9223 15.2163C13.7423 15.9738 13.0673 16.4988 12.2873 16.4988H2.43229C1.29979 16.4988 0.489806 15.3887 0.827306 14.3012L3.9848 4.16132C4.2023 3.45632 4.85481 2.96875 5.58981 2.96875H14.8148C15.5273 2.96875 16.1198 3.40375 16.3673 4.00375C16.5098 4.32625 16.5398 4.69379 16.4498 5.06879Z" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10"/>
                <path d="M12 16.5H15.585C16.5525 16.5 17.31 15.6825 17.2425 14.715L16.5 4.5" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M7.25781 4.78488L8.03782 1.54492" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12.2852 4.79208L12.9902 1.53711" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M5.77344 9H11.7734" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M5.02344 12H11.0234" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <div className='tracking-[-0.04em] text-[#032432]/60'>Новости</div>
            </div>
          </div>
          
          <div className='flex flex-col xl:flex-row items-center xl:items-end justify-between gap-[20px]'>
            <div>
              <h2 className='font-medium mt-[30px] text-[#032432] text-[24px] xl:text-[36px] text-center xl:text-start leading-none'>{Parser(block_news?.title)}</h2>
              <div className='mt-[10px] text-[14px] xl:text-[16px] text-center xl:text-start text-black/60 tracking-[-0.02em]'>{Parser(block_news?.text)}</div>
            </div>
            
            <div className='flex flex-col items-center gap-[10px]'>
              {more &&
                <a href={block_news?.more} className='flex items-center gap-[9px] text-[#032432]/60 text-[14px]'>
                  <div>Все новости</div>
                  <svg width="5" height="12" viewBox="0 0 5 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.433105 0.25L3.60234 5.75L0.433105 11.25" stroke="#032432" stroke-opacity="0.6"/>
                  </svg>
                </a>
              }
              
              {/* Кастомная навигация с полупрозрачностью */}
              <div className='hidden xl:flex items-center gap-[5px]'>
                <div 
                  className={`w-[38px] h-[38px] rounded-full bg-[#032432] cursor-pointer flex items-center justify-center transition-opacity duration-300 ${
                    isBeginning ? 'opacity-30 cursor-not-allowed' : 'opacity-100 hover:bg-opacity-80'
                  }`}
                  onClick={() => !isBeginning && this.swiperRef.current?.slidePrev()}
                >
                  <svg width="5" height="12" viewBox="0 0 5 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.75269 0.25L0.577271 5.75L3.75269 11.25" stroke="white"/>
                  </svg>
                </div>
                <div 
                  className={`w-[38px] h-[38px] rounded-full bg-[#032432] cursor-pointer flex items-center justify-center transition-opacity duration-300 ${
                    isEnd ? 'opacity-30 cursor-not-allowed' : 'opacity-100 hover:bg-opacity-80'
                  }`}
                  onClick={() => !isEnd && this.swiperRef.current?.slideNext()}
                >
                  <svg width="5" height="12" viewBox="0 0 5 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.433105 0.25L3.60852 5.75L0.433105 11.25" stroke="white"/>
                  </svg>
                </div>
              </div>
            </div>
          </div>

          {/* Слайдер с новостями */}
          <div className='mt-[20px]'>
            <Swiper
              onSwiper={(swiper) => {
                this.swiperRef.current = swiper
                this.handleSlideChange(swiper)
              }}
              onSlideChange={this.handleSlideChange}
              modules={[Navigation]}
              spaceBetween={10}
              slidesPerView={3}
              breakpoints={{
                0: {
                  slidesPerView: 1,
                  spaceBetween: 10
                },
                640: {
                  slidesPerView: 2,
                  spaceBetween: 10
                },
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 10
                }
              }}
              className='news-slider'
            >
              {(block_news?.cards || []).map((elm, index) => (
                <SwiperSlide key={index} className='h-auto'>
                  <a href={elm?.more} className='rounded-[15px] bg-[#F5F7F9] block h-full'>
                    <img 
                      src={elm.image} 
                      alt={elm.name} 
                      width={386} 
                      height={167} 
                      className='w-full h-[212px] object-cover bg-[#e1e1e1] rounded-t-[15px]' 
                    />
                    <div className='p-[20px]'>
                      <div className='text-[#032432] text-[16px] xl:text-[18px]'>{elm.name}</div>
                      <div className='text-black/60 text-[14px] xl:text-[16px] mt-[10px] tracking-[-0.02em]'>{elm.text}</div>
                      <div className='mt-[10px] flex items-center justify-start text-black/60 text-[14px] xl:text-[16px] gap-[4px]'>
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M6 1.5V3.75" stroke="#009EE3" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M12 1.5V3.75" stroke="#009EE3" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M5.25 8.25H11.25" stroke="#009EE3" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M5.25 11.25H9" stroke="#009EE3" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M11.25 16.5H6.75C3 16.5 2.25 14.955 2.25 11.865V7.2375C2.25 3.7125 3.5025 2.7675 6 2.625H12C14.4975 2.76 15.75 3.7125 15.75 7.2375V12" stroke="#009EE3" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M15.75 12L11.25 16.5V14.25C11.25 12.75 12 12 13.5 12H15.75Z" stroke="#009EE3" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <div>{elm.date}</div>
                      </div>
                    </div>
                  </a>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    );
  }
}

export default App